import script from "./DisplayCurriculumLanguages.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayCurriculumLanguages.vue?vue&type=script&setup=true&lang=js"

import "./DisplayCurriculumLanguages.vue?vue&type=style&index=0&id=68005c5f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68005c5f"]])

export default __exports__